module.exports = __webpack_public_path__ + "static/media/logo.14f6a750.svg";